'use strict';

var quickview = require('./quickview'),
	imagesLoaded = require('imagesloaded'),
	util = require('./util'),
	layout = require('./layout'),
	minicart = require('./minicart');


function initQuickViewButtons() {
	$('.tiles-container .product-image').on('mouseenter', function () {
		var $qvButton = $('#quickviewbutton');
		if ($qvButton.length === 0) {
			$qvButton = $('<a id="quickviewbutton" class="quickview">' + Resources.QUICK_VIEW + '<i class="fa fa-arrows-alt"></i></a>');
		}
		var $link = $(this).find('.thumb-link');

		$qvButton.attr({
			'href': $link.attr('href'),
			'title': $link.attr('title')
		}).appendTo(this);

		$qvButton.on('click', function (e) {
			e.preventDefault();
			var containerName;

			quickview.show({
				url: $(this).attr('href'),
				source: 'quickview',
				containerName: containerName || ''
			});
		});
	});
}

function initAddToCartLinks($container){
	$container.find('.js-add-to-cart-link').off('click').on('click', function () {
		let sizeValue = $(this).data('size');
		let productId = $(this).data('pid');
		let action = $(this).data('action');
		addToCart(productId, sizeValue, action);
	});

	function addToCart(productId, sizeValue, action) {
		$.ajax({
			type: 'POST',
			url: action,
			data: {
				pid: productId,
				size: sizeValue,
				isTaxRecalculationNeeded: false
			},
			success: function (html) {
				$(document).trigger('before.additem.tocart');
				minicart.minicartShow(html);
				$(document).trigger('product.addedToCart');
			},
			error: function (result) {
				console.info(`addToCart failed: ${result}`);
			}
		});
	}
}


function initTileSwatches($container) {
	$container.find('.js-swatch_list')
		.one('mouseenter', function () {
			var $tile = $(this).closest('.js-product_tile');

			// Record the current img
			$tile.find('.js-thumb_image').each(function() {
				var $image = $(this);
				$image.data('current', {
					src: $image[0].src,
					srcset: $image[0].srcset,
					alt: $image[0].alt,
					title: $image[0].title
				});
			});

			// Record the current color
			$tile.data('color-id', $tile.find('.js-product_tile-action.selected').data('color-id'));
		})
		.on('mouseleave', function () {
			// Restore current thumb image
			var $tile = $(this).closest('.js-product_tile'),
				thumbColor = $tile.data('color-id'),
				$thumbActions = $tile.find('.js-product_tile-action'),
				$thumbProduct = $tile.find('.js-product-view'),
				$thumbOutfit = $tile.find('.js-outfit-view'),
				$thumbRollover = $tile.find('.js-rollover-view');

			$thumbProduct.attr($thumbProduct.data('current'));
			$thumbOutfit.length && $thumbOutfit.attr($thumbOutfit.data('current'));
			$thumbRollover.length && $thumbRollover.attr($thumbRollover.data('current'));

			$thumbActions.removeClass('selected').filter(function() {
				return $(this).data("color-id") == thumbColor;
			}).addClass('selected');
		})
		.on('click', '.js-swatch', function (e) {
			e.preventDefault();
			if ($(this).hasClass('selected')) { return; }
			var $tile = $(this).closest('.js-product_tile'),
					variationId = $(this).data('variation-id'),
					$wishlist = $(this).parents(".js-product_tile").find(".js-wishlist-custom");

			updateWishListButton($wishlist, variationId);
			showSwatchThumbnail.call(this, true);// pass true if the swatch should stay selected

		})

		.on('mouseenter', '.js-swatch', function () {
			showSwatchThumbnail.call(this, false);
		});

	function showSwatchThumbnail(selectSwatch) {
		// Set the tile image to the values provided on the swatch data attributes
		var data = $(this).children('.js-swatch_image').data('thumb'),
				$tile = $(this).closest('.js-product_tile'),
				thumbColor = $(this).data('color-id'),
				thumbProductID = $(this).data('variation-id'),
				$thumbActions = $tile.find('.js-product_tile-action'),
				$thumbProduct = $tile.find('.js-product-view'),
				$thumbOutfit = $tile.find('.js-outfit-view'),
				$thumbRollover = $tile.find('.js-rollover-view'),
				$tileQV = $tile.find('.js-order_product-edit_link'),
				$tileQVurl = $tileQV.length > 0 ? $tileQV.attr('href') : '',
				$productIDregex = new RegExp(/([^/?#]+).html(?=[?#]|$)/),
				isMobSlider = $tile.find('.js-carousel-wrapper').length > 0;

		// If swatch won't stay selected
		$thumbProduct.attr({
			src: data.src,
			srcset: data.srcset,
			alt: data.alt,
			title: data.title
		});
		$thumbOutfit.length && $thumbOutfit.attr({
			src: data.srcOutfit,
			srcset: data.srcsetOutfit,
			alt: data.alt,
			title: data.title
		});
		$thumbRollover.length && $thumbRollover.attr({
			src: data.srcRollover,
			srcset: data.srcsetRollover,
			alt: data.alt,
			title: data.title
		});
		$thumbActions.removeClass('selected').filter(function() {
			return $(this).data("color-id") == thumbColor;
		}).addClass('selected');

		// If swatch should stay selected
		if (!!selectSwatch) {
			// Save previous pID & color
			var prevSelectedSwatch = $(this).closest('.js-swatch_list').find('.selected'),
					prevProductID = prevSelectedSwatch.data('variation-id');

			prevSelectedSwatch.removeClass('selected');
			$(this).addClass('selected');
			$tile.find('.js-product_link, .js-product_name').attr('href', $(this).attr('href'));

			$thumbProduct.data('current', {
				src: data.src,
				srcset: data.srcset,
				alt: data.alt,
				title: data.title
			});
			$thumbOutfit.length && $thumbOutfit.data('current', {
				src: data.srcOutfit,
				srcset: data.srcsetOutfit,
				alt: data.alt,
				title: data.title
			});
			$thumbRollover.length && $thumbRollover.data('current', {
				src: data.srcRollover,
				srcset: data.srcsetRollover,
				alt: data.alt,
				title: data.title
			});
			$tile.data('color-id', thumbColor);
			
			// Change quick view link according to the selected swatch data
			$tileQV.length && $tileQV.attr({
				href: $tileQVurl.replace($productIDregex, thumbProductID + '.html')
			});

			// Change mobile slider images
			if (util.isMobile() && isMobSlider) {
				showSwatchSliderMobile.call(this, $tile, prevProductID, thumbProductID);
			}

		}
	}
}

	// Replace product ID in src, data-src & data-srcset in each Owl slide's image
	// some images in the slider have just src, others have just data-src, 
	// and all images have data-srcset
function showSwatchSliderMobile($tile, prevProductID, thumbProductID) {
	var $owlItemsTiles = $tile.find('.owl-carousel-item'),
			// $carousel,
			$slideImg,
			$slideImgSrc,
			$slideImgSrcset,
			$slideImgDataSrc,
			$slideImgDataSrcset;
	
	if ($owlItemsTiles.length > 0){
		$owlItemsTiles.each(function(i){
			$slideImg = $(this).find('img');
			
			if ($slideImg.length > 0) {
				$slideImgSrc = $slideImg.attr('src');
				$slideImgSrcset = $slideImg.attr('srcset');
				$slideImgDataSrc = $slideImg.data('src');
				$slideImgDataSrcset = $slideImg.data('srcset');

				// Process both active slide and lazy-load slides, 
				// when 'load.owl.lazy' fires - src/srcset attr are populated from data-src/srcset
				$slideImg.attr({
					src: $slideImgSrc ? 
							 $slideImgSrc.replaceAll(prevProductID, thumbProductID) : 
							 $slideImgDataSrc.replaceAll(prevProductID, thumbProductID),
					srcset: $slideImgSrcset ? 
							 $slideImgSrcset.replaceAll(prevProductID, thumbProductID) : 
							 $slideImgDataSrcset.replaceAll(prevProductID, thumbProductID)
				});
				 $slideImg.data({
					 src: $slideImgDataSrc && $slideImgDataSrc.replaceAll(prevProductID, thumbProductID),
					 srcset: $slideImgDataSrcset && $slideImgDataSrcset.replaceAll(prevProductID, thumbProductID)
				 });

			}//if img
			
		});//map
	}
}

/**
 * @description Sets src/srcset from data attributes, unless the image already has a source (e.g. set by a swatch)
 * @param {jQuery} $images
 */
function setDynamicImagesSource($images) {
	$images.each(function () {
		var $image = $(this);

		if (!this.getAttribute('src') && $image.attr('data-src')) {
			$image.attr('srcset', $image.attr('data-srcset'));
			$image.attr('src', $image.attr('data-src'));
		}
	});
}

/**
 * @description Loads outfit images, they are visible in outfit view only (see pages/search/index.js changeImageView)
 * @param {jQuery} $container
 */
function loadOutfitImages($container) {
	setDynamicImagesSource($container.find('.js-outfit-view.js-dynamic-image'));
}

/**
 * @description Loads tile rollover image and shows it on hover when loaded (see .js-images-loaded in plp/_product_tile.scss)
 * @param {jQuery} $tile
 */
function loadRolloverImage($tile) {
	var $rollover = $tile.find('.js-rollover-view');

	// rollover is shown in the product grid only, not in recommendations, etc.
	if ($tile.data('rolloverRequested') || !$rollover.length || !$tile.closest('.js-search-result-items').length) {
		return;
	}

	$tile.data('rolloverRequested', true);
	setDynamicImagesSource($rollover);
	imagesLoaded($rollover).on('done', function () {
		$tile.addClass('js-images-loaded');
	});
}

var rolloverObserver = null;

/**
 * @description Preloads rollover images of tiles near the viewport on desktop, where rollover is shown on hover
 * @param {jQuery} $tiles
 */
function preloadRolloverImages($tiles) {
	if (!('IntersectionObserver' in window) || !layout.isDesktop()) {
		return;
	}

	if (!rolloverObserver) {
		rolloverObserver = new IntersectionObserver(function (entries) {
			entries.forEach(function (entry) {
				if (entry.isIntersecting) {
					rolloverObserver.unobserve(entry.target);
					loadRolloverImage($(entry.target));
				}
			});
		}, {rootMargin: '200px 0px'});
	}

	$tiles.each(function () {
		rolloverObserver.observe(this);
	});
}

/**
 * @description Hidden tile images are not loaded with the page: rollover is loaded for tiles near the viewport
 * or on the first hover over a tile, outfit - in outfit view only
 * @param {jQuery} $container
 */
function loadDynamicImages($container) {
	if ($('.js-product_search-container').hasClass('outfit-view')) {
		loadOutfitImages($container);
	}

	preloadRolloverImages($container);

	$container.one('mouseenter', '.product-image', function () {
		loadRolloverImage($(this).closest('.js-product_tile'));
	});
}

function initTileIndexes(options) {
		var $container, $tiles, start, pageHref, pageStart;

		if (!!options && 'container' in options) {
				$container = options.container;
				start = options.start;
		} else {
			pageHref = parseInt(util.getParameterValueFromUrl('page')) || 0;
			pageStart = (pageHref) ? pageHref - 1 : 0;
				$container = $('body');
				start = (pageStart <=  0) ? 0 : pageStart * 12;
		}
		$tiles = $container.find('.js-product_tile');

		if ($tiles.length === 0) {
			return false;
		}
		$tiles.each(function (idx) {
				$(this).data('idx', start + idx);
		});

		return $tiles;
}


function initWishListButtonsAction($container) {
		$container.on('click', '.js-wishlist-custom', handleWishListButtonsAction);
}

function updateWishListButton($item, productId) {
		var url = util.appendParamsToUrl(util.ajaxUrl(Urls.wishlistIsProductInProductList), {
				pid: productId
		});

		$.ajax({
				url: url,
				success: function(response) {
						if (response.success) {
								if ( response.status) {
										$item.addClass('active');
								} else {
										$item.removeClass('active');
								}
								$item.data('product-id', productId);
						}
				}
		});
}

function handleWishListButtonsAction(e) {
		e.preventDefault()	;
		var $item = $(this),
				productID = $item.data('product-id'),
				wishlisID = $item.data('wishlis-id'),
				isActive = $item.hasClass('active'),
				url = isActive ? Urls.wishlistRemoveProductVariants : Urls.wishlistAddProduct;

		url = util.appendParamsToUrl(util.ajaxUrl( url), {
				pid: productID,
				wishlisID: wishlisID,
				onlyVariant: true
		});
		$.ajax({
				url: url,
				success: function (response) {
						if (response.success) {
								if (isActive) {
										$item.removeClass('active');
										$item.data('wishlis-id', null);
								} else {
										$item.addClass('active');
										$item.data('wishlis-id', response.productListID);
								}
								updateHeaderWishListButtons();
								updateHeaderWishListQuantity();
						}
				}
		});
}

function updateHeaderWishListButtons() {
		var $item = $('.js-wishlist-custom-header'),
				url = util.appendParamsToUrl(util.ajaxUrl(Urls.wishlistIsHasProduct), {});

		$.ajax({
				url: url,
				success: function (response) {
						if (response.success) {
								if (response.status) {
										$item.addClass('active');
								} else {
										$item.removeClass('active');
								}
						}
				}
		});
}

function updateHeaderWishListQuantity() {
		var $item = $('.b-site_header .wishlist-quantity');

		$.ajax({
				url: location.href,
				dataType: 'html',
				success: function (response) {
					var $quantity = $(response).find('.b-site_header .wishlist-quantity');
					if ($item.length && $quantity.text()) {
						$item.text($quantity.text());
					}
				}
		});
}

/**
 * @private
 * @function
 * @description Initializes events on the product-tile for the following elements:
 * - swatches
 * - thumbnails
 */
function initializeEvents($container) {
	// initQuickViewButtons();
	loadDynamicImages($container);
	initTileSwatches($container);
	initWishListButtonsAction($container);
	initAddToCartLinks($container);
}

exports.init = function (options) {
		var $tiles = initTileIndexes(options);
		if (!$tiles) {
			return;
	}
	// init is called several times for the same tiles (page init, ajax updates, post-load): bind events once per tile
	$tiles = $tiles.filter(function () {
		return !$(this).data('tileInitialized');
	});
	if (!$tiles.length) {
		return;
	}
	$tiles.data('tileInitialized', true);
	initializeEvents($tiles);
};

exports.loadOutfitImages = loadOutfitImages;
